// テーブル見出し 文言
export const tableTitle = {
    company: '企業名',
    consultant: 'コンサルタント名',
    proposalRequest: '提案希望',
    status: 'ステータス',
    viewRequest: '企業名開示',
};
export const noDataTextOfApprove = '案件内容の開示を許可してください（案件責任者のみご対応可能）';
export const noDataText = 'Proffitが開示依頼の対応いたしますので、お手すきの際にコンサルのプロフィールなどをご確認ください';
